import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { SORT_ORDER } from 'globals.js';
import { INTERFACE } from 'pathnames.js';

// HELPERS
import { getListData } from 'helpers/getListData';
import DealTasksProvider from './dealTasks/helpers/DealTasksProvider.js';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table.js';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from '../../../columns.js';

// LOCAL COMPONENTS
import TasksCollapse from './dealTasks/parts/TasksCollapse.js';
import TasksBadge from './dealTasks/tools/TasksBadge';

// MAIN COMPONENT
const DealTasks = () => {
  return (
    <Main>
      <Title documentTitle="Deal Tasks" title="Deal Tasks" />
      <Filters>
        <Filters.Search />
      </Filters>
      <DealTasksProvider>
        <Table mobilePreviewKeys={['customer_name', 'delivered_date']} showNumber rowWrapper={TasksCollapse} />
      </DealTasksProvider>
    </Main>
  );
};

// EXPORT
export default getListData(DealTasks, {
  key: 'dealTasks',
  fetchArgs: {
    endpoint: ENDPOINTS.dealTasks.list
  },
  defaults: {
    sort: 'delivered_date',
    order: SORT_ORDER.descending
  },
  columns: [
    {
      key: 'task_cnt',
      label: 'Tasks',
      component: TasksBadge,
      width: 55
    },
    COLUMNS.deliveredDate,
    COLUMNS.deliveredAge,
    {
      ...COLUMNS.customer(INTERFACE.sales),
      key: 'customer_name',
      width: 80
    },
    {
      ...COLUMNS.purchaseLease,
      key: 'sale_type_code_first'
    },
    {
      ...COLUMNS.stockNumber
    },
    {
      ...COLUMNS.ageOfVehicle,
      key: 'age'
    },
    {
      ...COLUMNS.trades,
      key: 'trades'
    },
    {
      ...COLUMNS.frontendGross,
      key: 'front_end_gross'
    },
    {
      ...COLUMNS.amGross,
      component: Table.Dollars
    },
    {
      ...COLUMNS.fiGross,
      key: 'fl_gross' // This might be a typo in the BE
    },
    COLUMNS.totalGross,
    {
      ...COLUMNS.salesPerson,
      key: 'salesperson',
      label: 'Salesperson'
    },
    COLUMNS.fmManager
  ],
  actions: [ACTIONS.open(INTERFACE.sales, 'sales_id')],
  sortable: true
});
